const items = [
  {
    n: "01",
    title: "The Vahe Protocol",
    body: "A meticulous methodology that respects the natural architecture of the eyelid — avoiding the over-pulled look in favour of a soft, undetectable refinement.",
  },
  {
    n: "02",
    title: "London Standard",
    body: "Surgery delivered in a fully accredited central-London surgical suite, with luxury perioperative care managed with the utmost discretion.",
  },
  {
    n: "03",
    title: "Rapid Return",
    body: "Advanced micro-suturing techniques minimise bruising and swelling. Most patients return to social engagements within 7 to 10 days.",
  },
];

const Approach = () => {
  return (
    <section id="approach" className="bg-linen-deep py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16 md:mb-20">
          <span className="text-[10px] tracking-[0.35em] uppercase text-accent font-medium">
            The Approach
          </span>
          <h2 className="font-display text-4xl md:text-5xl mt-4 text-foreground">
            Sophisticated. Minimal. <span className="italic">Timeless.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-12 md:gap-16">
          {items.map((it) => (
            <div key={it.n} className="space-y-5">
              <div className="font-display text-3xl italic text-accent">{it.n}</div>
              <div className="h-px w-12 bg-accent/40" />
              <h3 className="text-xs uppercase tracking-[0.3em] font-medium text-foreground">
                {it.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed font-light">{it.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approach;
